module.exports = __webpack_public_path__ + "static/img/usit-logo-black.e3c9efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usit-logo-black.png
// module id = 0WuB
// module chunks = 1